// What the member sees, as the admin types it.
import React from 'react';
import FocusImage from './FocusImage';
import { DEFAULT_CTA } from './format';

const PhonePreview = ({ format, image, title, body, cta, placement, imageFocus, onFocusChange }) => {
  const sheet = placement === 'sheet';
  return (
    <div className="card">
      <h3>How it lands</h3>
      <div className="phone">
        <div className="p-status"><span>9:41</span><span>▮▮▮ ᯤ ▰</span></div>
        <div className="p-feed">
          <div className="p-brand">fav<em>♥</em>r</div>
          <div className="p-grid">
            <div className="p-cardm" /><div className="p-cardm" />
            <div className="p-cardm" /><div className="p-cardm" />
          </div>
        </div>
        <div className={`p-veil ${sheet ? 'sheet' : ''}`}>
          <div className="pop">
            {format !== 'text' && image && (
              <FocusImage src={image} focus={imageFocus} onChange={onFocusChange} />
            )}
            {format !== 'img' && (
              <div className="pop-body">
                <div className="pop-t">{title?.trim() || 'Your headline shows here'}</div>
                <div className="pop-s">
                  {body?.trim() || 'And the content underneath — exactly as members see it over the app.'}
                </div>
              </div>
            )}
            <div className="pop-cta">{cta?.trim() || DEFAULT_CTA}</div>
          </div>
        </div>
      </div>
      <div className="p-note">
        {placement === 'sheet'
          ? 'Rises from the bottom edge — the lighter interruption, and the one members can swipe away.'
          : 'Centred over the feed — the modal that stops everything until it is dismissed.'}
        {' '}The button closes it and opens the plans screen. Otherwise the member dismisses it, or it
        auto-closes after the seconds you set. Each render counts as one “seen”.
      </div>
    </div>
  );
};

export default PhonePreview;
